<template>
    <v-app-bar
      app
      color="rgba(255, 255, 255, 0.96)"
      elevation="1"
      elevate-on-scroll
    >
        <v-row no-gutters align="center">
          <router-link to="/">
            <app-logo />
          </router-link>

          <div class="d-none d-md-flex ml-16 gap-6 ">
            <router-link class="pua-text animated-link" to="/results">Resultados</router-link>
            <router-link class="pua-text animated-link" to="/pua-ai">Te ayudo a plantar</router-link>
            <router-link class="pua-text animated-link" to="/sobre-nosotros">Sobre nosotros</router-link>
            <router-link class="pua-text animated-link" to="/soy-plantador">¿Eres plantador?</router-link>
          </div>

          <v-spacer></v-spacer>

          <auth-control />
          <v-app-bar-nav-icon @click="showDrawer = !showDrawer" class="d-md-none"></v-app-bar-nav-icon>
        </v-row>
    </v-app-bar>
</template>

<script>
import AppLogo from '@/components/AppLogo';
import AuthControl from '@/components/AuthControl';

export default {
  name: 'NavHeader',

  components: {
    AppLogo,
    AuthControl,
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    }
  },

  computed: {
    showDrawer:{
      get(){
        return this.value;
      },
      set(newValue){
        this.$emit('input', newValue);
      }
    }
  }
}
</script>

<style scoped>
.animated-link {
  transition: ease-in-out 0.3s;
  padding: 5px 10px 5px 10px;
}
.animated-link:hover {
  background: #e1eee4;
  border-radius: 5px;
  padding: 5px 20px 5px 20px;
  transition: ease-in-out 0.5s;
}
</style>
